import "./styles/output.css";
import "./styles/layout.css";
import "./styles/index.scss";
import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { App } from "./App";
import { initLocalStorage } from "@/common/browserStorage/initLocalStorage";
import { utmController } from "@/common/utm/controller";

import(/* webpackPrefetch: true */ "core-js/stable");
import(/* webpackPrefetch: true */ "regenerator-runtime/runtime");
import(/* webpackPrefetch: true */ "./sentry");

initLocalStorage();
utmController();

const rootElement = document.getElementById("root");

const ErrorBoundaryPage = lazy(() => import("@/pages/ErrorBoundaryPage"));

if (!rootElement) {
  console.warn("No #root element found — skipping React bootstrap.");
} else {
  const root = createRoot(rootElement!);
  root.render(
    <StrictMode>
      <ErrorBoundary
        FallbackComponent={(props) => (
          <Suspense fallback={null}>
            <ErrorBoundaryPage {...props} />
          </Suspense>
        )}
      >
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
}
